import React, { useState } from "react"

import { Col, Row } from "react-bootstrap"
import { TextField ,Button } from "@material-ui/core"
const ContactForm = () => {
  const GATEWAY_URL = 'https://xjqa1uyn46.execute-api.eu-west-1.amazonaws.com/Production';
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [userData, setUserData] = useState(
     {
      name: "",
      mail: "",
      message: "",
      number: "",
      adress: "",
    }
  )
  const handleChange = name => event => {
    setUserData({ ...userData, [name]: event.target.value })
  }
  const onSubmit = () => {
    setIsSubmitting(true)
    let message = JSON.stringify(userData,null,'\t')
   
    try {
      fetch(GATEWAY_URL, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify({message:message,name:userData.name}),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      });
    } catch (error) {
      // handle server errors
    }
  };

  return (
    <Row className="mb-5 mt-5">
      <Col md={12}>
        <h1 className="mt-5">Kontaktformular</h1>
      </Col>
      <Col md={12}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Vorname Nachname"
          label="Name"
          value={userData.name}
          onChange={handleChange("name")}
        />
      </Col>
      <Col md={12}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Email"
          label="Email"
          value={userData.email}
          onChange={handleChange("mail")}
        />
      </Col>

      <Col md={12}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Adresse"
          label="Adresse"
          value={userData.adress}
          onChange={handleChange("adress")}
        />
      </Col>
      <Col md={12}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Telefonnummer"
          label="Telefonnummer"
          value={userData.number}
          onChange={handleChange("number")}
        />
      </Col>
      <Col md={12}>
        <TextField
          variant="outlined"
          fullWidth
          multiline
          placeholder="Ihre Nachricht an uns"
          label="Nachricht"
          value={userData.message}
          rows="4"
          rowsMax="4"
          onChange={handleChange("message")}
        />
      </Col>
      <Col>
        <Button disabled={isSubmitting} color="primary" variant="outlined" onClick={()=>onSubmit()}>Absenden</Button>
      </Col>
    </Row>
  )
}

export default ContactForm
